"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchGovernanceIdentitiesDetails = exports.fetchGovernanceSecretsCount = exports.fetchGovernanceIdentitiesList = exports.fetchGovernanceSecretsDetails = exports.fetchGovernanceSecretsList = exports.withdrawRequest = exports.validatePassword = exports.downloadSecretFile = exports.createSecret = exports.updateSecret = exports.deletePasswordPolicy = exports.fetchPasswordPolicyList = exports.editPasswordPolicy = exports.addPasswordPolicy = exports.staticSecretTemplateDeleteAPI = exports.staticSecretTemplateListAPI = exports.editStaticSecretReq = exports.staticSecretTemplateByIdAPI = exports.getPwdPolicies = exports.addStaticSecret = exports.rotateVaultKey = exports.deleteVault = exports.editVault = exports.fetchChannelList = exports.fetchTags = exports.fetchUsers = exports.fetchNotificationMediumList = exports.createVault = exports.fetchSecretDetails = exports.getSecretDetails = void 0;

var _apiService = _interopRequireDefault(require("../utils/api-service"));

var _commonUtils = require("../utils/common-utils");

var _commonConstants = require("../utils/common-constants");

var _utils = require("../packages/secret-manager/modules/secrets/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//NOTE: Common Headers Services
var headers = {
  'content-type': 'application/json'
};

var getSecretDetails = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var parents, vaultId, data, requiredString, params, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            parents = _ref.parents, vaultId = _ref.vaultId, data = _ref.data;
            requiredString = (0, _commonUtils.getRequiredString)(parents);
            params = {};
            params.path = requiredString;
            _context.next = 6;
            return _apiService.default.post("/api/v1/secretmanager/vault/".concat(vaultId, "/accesssecrets"), data || {}, {
              params: params
            });

          case 6:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getSecretDetails(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getSecretDetails = getSecretDetails;

var fetchSecretDetails = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(payload) {
    var parentPath, vaultId, params, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            parentPath = payload.parentPath, vaultId = payload.vaultId;
            params = {};
            params.path = parentPath;
            params.getmetadata = true;
            _context2.next = 6;
            return _apiService.default.get("/api/v1/secretmanager/vault/".concat(vaultId, "/secrets"), {
              params: params
            });

          case 6:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchSecretDetails(_x2) {
    return _ref3.apply(this, arguments);
  };
}(); // *************************************************************************************************************
//NOTE: Vault CRUD Services

/***** Create Vault Api Call */


exports.fetchSecretDetails = fetchSecretDetails;

var createVault = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(payload) {
    var create;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _apiService.default.post("/api/v1/secretmanager/vault", payload, {
              headers: headers
            });

          case 2:
            create = _context3.sent;
            return _context3.abrupt("return", create.status);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function createVault(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
/***** Get Notification List Api Call */


exports.createVault = createVault;

var fetchNotificationMediumList = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var response;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _apiService.default.get('/api/v1/notification-service/notificationmediums');

          case 2:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchNotificationMediumList() {
    return _ref5.apply(this, arguments);
  };
}();
/***** Get Users Api Call */


exports.fetchNotificationMediumList = fetchNotificationMediumList;

var fetchUsers = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    var response;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _apiService.default.get('/api/users?type=User', {
              headers: headers
            });

          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", ((response === null || response === void 0 ? void 0 : response.data) || []).filter(function (user) {
              return user.status.toLowerCase() === _commonConstants.active;
            }));

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchUsers() {
    return _ref6.apply(this, arguments);
  };
}();
/***** Get Tags Api Call */


exports.fetchUsers = fetchUsers;

var fetchTags = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    var response;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _apiService.default.get('/api/user-tags', {
              headers: headers
            });

          case 2:
            response = _context6.sent;
            return _context6.abrupt("return", ((response === null || response === void 0 ? void 0 : response.data) || []).filter(function (tag) {
              return tag.status.toLowerCase() === _commonConstants.active;
            }));

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function fetchTags() {
    return _ref7.apply(this, arguments);
  };
}();
/***** Get Channels Api Call */


exports.fetchTags = fetchTags;

var fetchChannelList = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(channelId) {
    var response;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _apiService.default.get("/api/v1/notification-service/notificationmediums/".concat(channelId, "/channels"));

          case 2:
            response = _context7.sent;
            return _context7.abrupt("return", (response === null || response === void 0 ? void 0 : response.data) || []);

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function fetchChannelList(_x4) {
    return _ref8.apply(this, arguments);
  };
}();
/***** Edit Vault Api Call */


exports.fetchChannelList = fetchChannelList;

var editVault = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(payload, id) {
    var update;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _apiService.default.patch("/api/v1/secretmanager/vault/".concat(id), payload, {
              headers: headers
            });

          case 2:
            update = _context8.sent;
            return _context8.abrupt("return", update);

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function editVault(_x5, _x6) {
    return _ref9.apply(this, arguments);
  };
}();
/***** Delete Vault Api Call */


exports.editVault = editVault;

var deleteVault = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
    var response;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _apiService.default.delete("/api/v1/secretmanager/vault/".concat(id));

          case 2:
            response = _context9.sent;
            return _context9.abrupt("return", response.data);

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function deleteVault(_x7) {
    return _ref10.apply(this, arguments);
  };
}();
/***** Rotate Vault Api Call */


exports.deleteVault = deleteVault;

var rotateVaultKey = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
    var response;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return _apiService.default.post('/api/v1/secretmanager/keys/rotate', {
              headers: headers
            });

          case 2:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 4:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function rotateVaultKey() {
    return _ref11.apply(this, arguments);
  };
}(); // *************************************************************************************************************
//NOTE: SST CRUD Services

/***** Add SST Api Call */


exports.rotateVaultKey = rotateVaultKey;

var addStaticSecret = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(data) {
    var response;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return _apiService.default.post('/api/v1/secretmanager/secret-templates/static', JSON.parse(data), {
              headers: headers
            });

          case 2:
            response = _context11.sent;
            return _context11.abrupt("return", response.data);

          case 4:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function addStaticSecret(_x8) {
    return _ref12.apply(this, arguments);
  };
}();
/***** Get PwdPolicies on SST Api Call */


exports.addStaticSecret = addStaticSecret;

var getPwdPolicies = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
    var response;
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return _apiService.default.get('/api/v1/secretmanager/pwdpolicies');

          case 2:
            response = _context12.sent;
            return _context12.abrupt("return", response.data);

          case 4:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function getPwdPolicies() {
    return _ref13.apply(this, arguments);
  };
}();
/***** Get SST Details Api Call */


exports.getPwdPolicies = getPwdPolicies;

var staticSecretTemplateByIdAPI = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(secretId) {
    var response;
    return regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return _apiService.default.get("/api/v1/secretmanager/secret-templates/static/".concat(secretId));

          case 2:
            response = _context13.sent;
            return _context13.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function staticSecretTemplateByIdAPI(_x9) {
    return _ref14.apply(this, arguments);
  };
}();
/***** Edit SST Api Call */


exports.staticSecretTemplateByIdAPI = staticSecretTemplateByIdAPI;

var editStaticSecretReq = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(data, id) {
    var response;
    return regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return _apiService.default.patch("/api/v1/secretmanager/secret-templates/static/".concat(id), JSON.parse(data), {
              headers: headers
            });

          case 2:
            response = _context14.sent;
            return _context14.abrupt("return", response.data);

          case 4:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function editStaticSecretReq(_x10, _x11) {
    return _ref15.apply(this, arguments);
  };
}();
/***** Get SST List Api Call */


exports.editStaticSecretReq = editStaticSecretReq;

var staticSecretTemplateListAPI = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(_ref16) {
    var search, next, _ref16$filter, filter, params, tableList;

    return regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            search = _ref16.search, next = _ref16.next, _ref16$filter = _ref16.filter, filter = _ref16$filter === void 0 ? 'co' : _ref16$filter;
            params = {};

            if (search) {
              params.filter = "name%20".concat(filter, "%20'").concat(search, "'");
            }

            if (next) {
              params.pageToken = (0, _commonUtils.getQueryParamsFromUrl)(next, _commonConstants.PAGE_TOKEN);
            }

            _context15.next = 6;
            return _apiService.default.get('/api/v1/secretmanager/secret-templates/static', {
              params: params
            });

          case 6:
            tableList = _context15.sent;
            return _context15.abrupt("return", tableList.data);

          case 8:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function staticSecretTemplateListAPI(_x12) {
    return _ref17.apply(this, arguments);
  };
}();
/***** Delete SST Api Call */


exports.staticSecretTemplateListAPI = staticSecretTemplateListAPI;

var staticSecretTemplateDeleteAPI = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(id) {
    var response;
    return regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return _apiService.default.delete("/api/v1/secretmanager/secret-templates/static/".concat(id));

          case 2:
            response = _context16.sent;
            return _context16.abrupt("return", response.status);

          case 4:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function staticSecretTemplateDeleteAPI(_x13) {
    return _ref18.apply(this, arguments);
  };
}();
/*Add password policy api*/


exports.staticSecretTemplateDeleteAPI = staticSecretTemplateDeleteAPI;

var addPasswordPolicy = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(passwordPolicyData) {
    var response;
    return regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return _apiService.default.post('/api/v1/secretmanager/pwdpolicies', passwordPolicyData);

          case 2:
            response = _context17.sent;
            return _context17.abrupt("return", response.data);

          case 4:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));

  return function addPasswordPolicy(_x14) {
    return _ref19.apply(this, arguments);
  };
}();
/*Edit password policy api*/


exports.addPasswordPolicy = addPasswordPolicy;

var editPasswordPolicy = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(passwordPolicyId, payloadData) {
    var response;
    return regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return _apiService.default.patch("/api/v1/secretmanager/pwdpolicies/".concat(passwordPolicyId), payloadData);

          case 2:
            response = _context18.sent;
            return _context18.abrupt("return", response.data);

          case 4:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function editPasswordPolicy(_x15, _x16) {
    return _ref20.apply(this, arguments);
  };
}();
/*Password policy list api*/


exports.editPasswordPolicy = editPasswordPolicy;

var fetchPasswordPolicyList = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
    var payload,
        params,
        response,
        _args19 = arguments;
    return regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            payload = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : {};
            params = {};

            if (payload.search) {
              params.filter = "name%20co%20'".concat(payload.search, "'");
            }

            if (payload.next) {
              params.pageToken = (0, _commonUtils.getQueryParamsFromUrl)(payload.next, _commonConstants.PAGE_TOKEN);
            }

            _context19.next = 6;
            return _apiService.default.get('/api/v1/secretmanager/pwdpolicies', {
              params: params
            });

          case 6:
            response = _context19.sent;
            return _context19.abrupt("return", response.data);

          case 8:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));

  return function fetchPasswordPolicyList() {
    return _ref21.apply(this, arguments);
  };
}();
/* Delete Password policy api */


exports.fetchPasswordPolicyList = fetchPasswordPolicyList;

var deletePasswordPolicy = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
    var payload,
        id,
        response,
        _args20 = arguments;
    return regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            payload = _args20.length > 0 && _args20[0] !== undefined ? _args20[0] : {};
            id = payload.id;
            _context20.next = 4;
            return _apiService.default.delete("/api/v1/secretmanager/pwdpolicies/".concat(id));

          case 4:
            response = _context20.sent;
            return _context20.abrupt("return", response.data);

          case 6:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));

  return function deletePasswordPolicy() {
    return _ref22.apply(this, arguments);
  };
}();

exports.deletePasswordPolicy = deletePasswordPolicy;

var updateSecret = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(_ref23) {
    var payloadBody, parents, vaultId, string, requiredString, response, formData;
    return regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            payloadBody = _ref23.payloadBody, parents = _ref23.parents, vaultId = _ref23.vaultId;
            string = (0, _commonUtils.getRequiredString)(parents);
            requiredString = encodeURIComponent(string);
            response = null;

            if (!(0, _utils.hasFileField)(payloadBody.value)) {
              _context21.next = 11;
              break;
            }

            formData = (0, _utils.getFileFormData)(payloadBody);
            _context21.next = 8;
            return _apiService.default.patch("/api/v1/secretmanager/vault/".concat(vaultId, "/secrets/file?path=").concat(requiredString), formData, {
              'Content-Type': 'multipart/form-data'
            });

          case 8:
            response = _context21.sent;
            _context21.next = 14;
            break;

          case 11:
            _context21.next = 13;
            return _apiService.default.patch("/api/v1/secretmanager/vault/".concat(vaultId, "/secrets?path=").concat(requiredString), payloadBody);

          case 13:
            response = _context21.sent;

          case 14:
            return _context21.abrupt("return", response.data);

          case 15:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));

  return function updateSecret(_x17) {
    return _ref24.apply(this, arguments);
  };
}();

exports.updateSecret = updateSecret;

var createSecret = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(_ref25) {
    var payloadBody, parents, vaultId, string, requiredString, response, formData;
    return regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            payloadBody = _ref25.payloadBody, parents = _ref25.parents, vaultId = _ref25.vaultId;
            string = (0, _commonUtils.getRequiredString)(parents);
            requiredString = encodeURIComponent(string);
            response = null;

            if (!(0, _utils.hasFileField)(payloadBody.value)) {
              _context22.next = 11;
              break;
            }

            formData = (0, _utils.getFileFormData)(payloadBody);
            _context22.next = 8;
            return _apiService.default.post("/api/v1/secretmanager/vault/".concat(vaultId, "/secrets/file?path=").concat(requiredString), formData, {
              'Content-Type': 'multipart/form-data'
            });

          case 8:
            response = _context22.sent;
            _context22.next = 14;
            break;

          case 11:
            _context22.next = 13;
            return _apiService.default.post("/api/v1/secretmanager/vault/".concat(vaultId, "/secrets?path=").concat(requiredString), payloadBody);

          case 13:
            response = _context22.sent;

          case 14:
            return _context22.abrupt("return", response.data);

          case 15:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));

  return function createSecret(_x18) {
    return _ref26.apply(this, arguments);
  };
}();

exports.createSecret = createSecret;

var downloadSecretFile = /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(_ref27) {
    var parents, vaultId, string, requiredString, response;
    return regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            parents = _ref27.parents, vaultId = _ref27.vaultId;
            string = parents.length ? "/".concat(parents.join('/')) : '/';
            requiredString = encodeURIComponent(string);
            _context23.next = 5;
            return _apiService.default.get("/api/v1/secretmanager/vault/".concat(vaultId, "/downloadfile?path=").concat(requiredString), {
              responseType: 'blob'
            });

          case 5:
            response = _context23.sent;
            return _context23.abrupt("return", response.data);

          case 7:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));

  return function downloadSecretFile(_x19) {
    return _ref28.apply(this, arguments);
  };
}();

exports.downloadSecretFile = downloadSecretFile;

var validatePassword = /*#__PURE__*/function () {
  var _ref30 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(_ref29) {
    var id, passwordOrPin, response;
    return regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            id = _ref29.id, passwordOrPin = _ref29.passwordOrPin;
            _context24.next = 3;
            return _apiService.default.post("/api/v1/secretmanager/pwdpolicies?action=validatePasswordOrPin", {
              id: id,
              passwordOrPin: passwordOrPin
            });

          case 3:
            response = _context24.sent;
            return _context24.abrupt("return", response);

          case 5:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));

  return function validatePassword(_x20) {
    return _ref30.apply(this, arguments);
  };
}();

exports.validatePassword = validatePassword;

var withdrawRequest = /*#__PURE__*/function () {
  var _ref31 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(requestId) {
    var response;
    return regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            _context25.next = 2;
            return _apiService.default.delete("/api/v1/approvals/".concat(requestId));

          case 2:
            response = _context25.sent;
            return _context25.abrupt("return", response.data);

          case 4:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));

  return function withdrawRequest(_x21) {
    return _ref31.apply(this, arguments);
  };
}(); //NOTE: Secrets Governance CRUD Services

/***** /*secrets list api*/


exports.withdrawRequest = withdrawRequest;

var fetchGovernanceSecretsList = /*#__PURE__*/function () {
  var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
    var payload,
        params,
        response,
        _response,
        _args26 = arguments;

    return regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            payload = _args26.length > 0 && _args26[0] !== undefined ? _args26[0] : {};
            params = {};

            if (payload.search) {
              params.filter = "name%20co%20'".concat(payload.search, "'");
            }

            if (!(payload !== null && payload !== void 0 && payload.next)) {
              _context26.next = 10;
              break;
            }

            _context26.next = 6;
            return _apiService.default.get("/api/governance/secrets?".concat(payload.next));

          case 6:
            response = _context26.sent;
            return _context26.abrupt("return", response.data);

          case 10:
            _context26.next = 12;
            return _apiService.default.get('/api/governance/secrets', {
              params: params
            });

          case 12:
            _response = _context26.sent;
            return _context26.abrupt("return", _response.data);

          case 14:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));

  return function fetchGovernanceSecretsList() {
    return _ref32.apply(this, arguments);
  };
}();
/***** /*secrets details api*/


exports.fetchGovernanceSecretsList = fetchGovernanceSecretsList;

var fetchGovernanceSecretsDetails = /*#__PURE__*/function () {
  var _ref33 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
    var payload,
        params,
        response,
        _response2,
        _args27 = arguments;

    return regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            payload = _args27.length > 0 && _args27[0] !== undefined ? _args27[0] : {};
            params = {};

            if (payload.search) {
              params.filter = "name%20co%20'".concat(payload.search, "'");
            }

            if (!(payload !== null && payload !== void 0 && payload.next)) {
              _context27.next = 10;
              break;
            }

            _context27.next = 6;
            return _apiService.default.get("/api/governance/identities/secrets/".concat(payload.id, "?").concat(payload.next));

          case 6:
            response = _context27.sent;
            return _context27.abrupt("return", response.data);

          case 10:
            _context27.next = 12;
            return _apiService.default.get("/api/governance/identities/secrets/".concat(payload.id), {
              params: params
            });

          case 12:
            _response2 = _context27.sent;
            return _context27.abrupt("return", _response2.data);

          case 14:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));

  return function fetchGovernanceSecretsDetails() {
    return _ref33.apply(this, arguments);
  };
}();
/***** /*identities list api*/


exports.fetchGovernanceSecretsDetails = fetchGovernanceSecretsDetails;

var fetchGovernanceIdentitiesList = /*#__PURE__*/function () {
  var _ref34 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
    var payload,
        params,
        response,
        _response3,
        _args28 = arguments;

    return regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            payload = _args28.length > 0 && _args28[0] !== undefined ? _args28[0] : {};
            params = {};

            if (payload.search) {
              params.filter = "name%20co%20'".concat(payload.search, "'");
            }

            if (!(payload !== null && payload !== void 0 && payload.next)) {
              _context28.next = 10;
              break;
            }

            _context28.next = 6;
            return _apiService.default.get("/api/governance/identities?".concat(payload.next));

          case 6:
            response = _context28.sent;
            return _context28.abrupt("return", response.data);

          case 10:
            _context28.next = 12;
            return _apiService.default.get('/api/governance/identities', {
              params: params
            });

          case 12:
            _response3 = _context28.sent;
            return _context28.abrupt("return", _response3.data);

          case 14:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28);
  }));

  return function fetchGovernanceIdentitiesList() {
    return _ref34.apply(this, arguments);
  };
}();
/***** Get: API for secrets & identities count */


exports.fetchGovernanceIdentitiesList = fetchGovernanceIdentitiesList;

var fetchGovernanceSecretsCount = /*#__PURE__*/function () {
  var _ref35 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
    var response;
    return regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            _context29.next = 2;
            return _apiService.default.get('/api/governance/count');

          case 2:
            response = _context29.sent;
            return _context29.abrupt("return", response.data);

          case 4:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29);
  }));

  return function fetchGovernanceSecretsCount() {
    return _ref35.apply(this, arguments);
  };
}();
/***** /*identities details api*/


exports.fetchGovernanceSecretsCount = fetchGovernanceSecretsCount;

var fetchGovernanceIdentitiesDetails = /*#__PURE__*/function () {
  var _ref36 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
    var payload,
        params,
        response,
        _response4,
        _args30 = arguments;

    return regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            payload = _args30.length > 0 && _args30[0] !== undefined ? _args30[0] : {};
            params = {};

            if (payload.search) {
              params.filter = "name%20co%20'".concat(payload.search, "'");
            }

            if (!(payload !== null && payload !== void 0 && payload.next)) {
              _context30.next = 10;
              break;
            }

            _context30.next = 6;
            return _apiService.default.get("/api/governance/secrets/identities/".concat(payload.id, "?").concat(payload.next));

          case 6:
            response = _context30.sent;
            return _context30.abrupt("return", response.data);

          case 10:
            _context30.next = 12;
            return _apiService.default.get("/api/governance/secrets/identities/".concat(payload.id), {
              params: params
            });

          case 12:
            _response4 = _context30.sent;
            return _context30.abrupt("return", _response4.data);

          case 14:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30);
  }));

  return function fetchGovernanceIdentitiesDetails() {
    return _ref36.apply(this, arguments);
  };
}();

exports.fetchGovernanceIdentitiesDetails = fetchGovernanceIdentitiesDetails;